// Must stay the first import: errors thrown before init() are not captured.
import "./appsignal";
import "./controllers"

// Entry point for the build script in your package.json
import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
ActiveStorage.start()
